import React from 'react'
import '../../styles/index.scss'
import '../../styles/navbar/styles.scss'
import autobind from '../../lib/autobind'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import Link from '../Link'

class LoginButton extends React.Component {
  constructor (props, context) {
    super(props, context)
    autobind(this)
    this.state = {
      shouldShowModal: this.checkLoginQuery()
    }
  }

  checkLoginQuery () {
    return Boolean(get(this, 'context.router.location.query.login'))
  }

  render () {
    const Button = this.props.type || 'button'
    const { REACT_APP_LOGIN_PORTAL_URL } = window.env
    return (
      <div className='login-logout'>
        <div className='login'>
          <Link href={REACT_APP_LOGIN_PORTAL_URL}>
            <Button id='login-open-modal-button' className='navbar__link navbar__link--button'>
              Log In
            </Button>
          </Link>
        </div>
      </div>
    )
  }
}

LoginButton.propTypes = {
  router: PropTypes.object,
  session: PropTypes.object,
  user: PropTypes.object
}

export default LoginButton
